

var Model = require("../types/Model.js");
var xtend = require("xtend");

var TYPE_MAP = {
	"metawear": "activity",
	"a&dweight": "weight",
	"a&dbloodpressure": "bloodpressure",
	"biosbloodpressure": "bloodpressure",
	"nonin": "spo2",
	"foratng": "bloodsugar",
	"forair20": "bodytemperature",
	"ihbloodpressure": "bloodpressure",
	"ihweight": "weight",
	"foraspo2": "spo2",
	"ihspo2": "spo2"
};

module.exports = Model({
	name: "manageddevices",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	refresh: refresh,
	reset: reset,
	processList: processList,
	errorExists: errorExists
});

function init() {
	this.push({
		list: [],
		updating: null,
		removing: null
	});
	this._list = [];
	this._removing = false;
	this._updating = false;
	this._who = false;
	this._who_tracker = this.dispatcher.createTracker();
}

function uninit(){
	this._who_tracker.off();
	this._who_tracker = null;
}

function triggers() {
	return {
		"view": view,
		"reset": reset,
		"cancel": cancel,

		"add:start": addStart,
		"add:submit": addFinish,

		"remove:start": removeStart,
		"remove:submit": removeFinish,
		"remove:cancel": removeCancel,

		"update:start": updateStart,
		"update:submit": updateFinish,
	};
}

function listeners() {
	return {
		"connectivity:online": refresh
	};
}

function view(data){
	this._who = data.who;
	this._group = data.group;
	this.dispatch("viewing");
	this.emit("bluetooth:trigger:initialize");
	this.emit("managedbluetoothscanner:trigger:initialize", {
		who: data.who,
		group: data.group
	});
	this.refresh();
	this.emit("usermetrics:trigger:track", "view managed user's bluetooth devices", {
		who: data.who
	});
}

function refresh(){
	var who = this._who;
	var group = this._group;
	if(!who) return;

	this.emit("save:trigger:start");
	return this.api.manage.devices.list(who, group)
		.then(processList.bind(this))
		.then(track.bind(this))
		.catch(handle_error.bind(this));
}

function processList(list){
	var sortedList = list.sort(sortByBattery);
	this.emit("save:trigger:finish");
	this._list = sortedList;
	this.extend({
		list: sortedList
	});
}

function handle_device_add(device){
	var current = this._list;
	var newList = current.concat(device);
	this.processList(newList);
}

function handle_device_update(device){
	var device_id = device._id;
	var current = this._list;
	var newList = current.map(function(ele){
		if(ele._id === device_id)
			return xtend(ele, device);
		return ele;
	});
	this.processList(newList);
}

function handle_device_battery_update(data){
	var device_id = data.device;
	var batteryLevel = data.battery;

	var current = this._list;
	var newList = current.map(function(ele){
		if(ele._id === device_id)
			return xtend(ele, {
				battery_level: batteryLevel
			});
		return ele;
	});
	this.processList(newList);
}

function handle_device_remove(device){
	var current = this._list;
	var newList = current.filter(function(ele){
		return ele._id !== device;
	});
	this.processList(newList);
}

function addStart(){
	this.dispatch("adding");
	this.emit("usermetrics:trigger:track", "begin adding new device to managed user");
}

function addFinish(data){
	var who = this._who;
	var group = this._group;
	var device = xtend(data, {
		device_type: TYPE_MAP[data.model]
	});

	var list = this._list;
	var checkExists = checkMacExists(list, device);
	if(checkExists) {
		this.emit("usermetrics:trigger:track", "attempt to add already existing device to managed user", {
			who: who
		});
		return this.errorExists();
	}

	this.emit("usermetrics:trigger:track", "submit add device to managed user", {
		who: who
	});
	return this.api.manage.devices.add(device, who, group)
		.then(finish.bind(this));
}

function removeStart(data){
	this._removing = data.device;
	this.extend({
		removing: data.device
	});
	this.dispatch("removing");
	this.emit("usermetrics:trigger:track", "open remove device from managed user popup", {
		who: this._who
	});
}

function removeFinish(){
	var who = this._who;
	var group = this._group;
	var removing = this._removing;
	this.emit("usermetrics:trigger:track", "submit remove device from managed user", {
		who: who
	});
	return this.api.manage.devices.remove(removing, who, group)
		.then(finish.bind(this));
}

function updateStart(data){
	this._updating = data.device;
	this.extend({
		updating: data.device
	});
	this.dispatch("updating");
	this.emit("usermetrics:trigger:track", "open update managed user's device popup", {
		who: this._who
	});
}

function updateFinish(data){
	var who = this._who;
	var group = this._group;
	var updating = this._updating;
	var device = xtend(updating, xtend(data, {
		device_type: TYPE_MAP[data.model]
	}));
	var list = this._list;
	var checkExists = checkMacExists(list, device);
	if(checkExists) {
		this.emit("usermetrics:trigger:track", "attempt to update to already existing device to managed user", {
			who: who
		});
		return this.errorExists();
	}
	this.emit("usermetrics:trigger:track", "submit update managed user's device", {
		who: who
	});
	return this.api.manage.devices.update(device, who, group)
		.then(finish.bind(this));
}

function cancel(){
	this._updating = false;
	this._removing = false;
	this.extend({
		updating: null,
		removing: null
	});
	this.emit("usermetrics:trigger:track", "cancel add new device to managed user");
}

function removeCancel(){
	this._removing = false;
	this.extend({
		removing: null
	});
	this.emit("usermetrics:trigger:track", "cancel remove device from managed user");
}

function finish(){
	this.dispatch("finished");
}

function track(){
	var who = this._who;
	var tracker = this._who_tracker;
	var group = this._group;

	tracker.off();

	if(group) {
		if(Array.isArray(group)) {
			group.forEach(g=>{
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/devices/added", handle_device_add.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/devices/updated", handle_device_update.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/devices/removed", handle_device_remove.bind(this));
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/devices/battery/updated", handle_device_battery_update.bind(this));
			});
		} else {
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/devices/added", handle_device_add.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/devices/updated", handle_device_update.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/devices/removed", handle_device_remove.bind(this));
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/devices/battery/updated", handle_device_battery_update.bind(this));
		}
	} else {
		tracker.on("mqtt:u/" + who + "/devices/added", handle_device_add.bind(this));
		tracker.on("mqtt:u/" + who + "/devices/updated", handle_device_update.bind(this));
		tracker.on("mqtt:u/" + who + "/devices/removed", handle_device_remove.bind(this));
		tracker.on("mqtt:u/" + who + "/devices/battery/updated", handle_device_battery_update.bind(this));
	}
}

function reset(){
	this._who = null;
	this._list = [];
	this._updating = false;
	this._removing = false;
	this.emit("managedbluetoothscanner:trigger:reset");
	this.push({
		list: [],
		updating: null,
		removing: null
	});
}

function handle_error(){
	this.emit("save:trigger:finish");
}

function checkMacExists(devices, device){
	return devices.reduce(function(acc, dev){
		if(dev.mac === device.mac && dev._id !== device._id) acc = true;
		return acc;
	}, false);
}

function errorExists(){
	this.emit("toast:trigger:show", {
		content: "devices.errorexists",
		style: "error"
	});
}

function sortByBattery(a, b){
	if(a.battery_level === 0) return 1;
	if(b.battery_level === 0) return -1;
	return a.battery_level - b.battery_level;
}